<ng-container *fcMediaWrapper="'desktop'">
    <fcp-summary-bar
        [title]="'ORDER.PRODUCT_DETAILS.SUMMARY' | translate"
        [summary]="summary | async"
        [button]="{
            label: 'ORDER.PRODUCT_DETAILS.ADD_TO_CART' | translate,
            enabled: buttonEnabled()
        }"
        (onClick)="onClick.emit()"
    ></fcp-summary-bar>
</ng-container>

<ng-container *fcMediaWrapper="'mobile'">
    <ng-container *ngLet="summary | async as summary">
        <div class="fc-pdp-mobile-summary">
            <div class="fc-pdp-mobile-summary-content-container">
                <div class="fc-pdp-mobile-summary-content">
                    <span> {{ summary.second.title }}: </span>
                    <span class="fc-pdp-mobile-summary-content-value">
                        {{ summary.second.value }}
                    </span>
                </div>
                <div class="fc-pdp-mobile-summary-content">
                    <span> {{ summary.third.title }}: </span>
                    <span class="fc-pdp-mobile-summary-content-value">
                        {{ summary.third.value }}
                    </span>
                </div>
            </div>
            <button
                class="fc-pdp-mobile-summary-button"
                fcp-button
                (click)="onClick.emit()"
                [disabled]="!buttonEnabled()"
            >
                {{ 'ORDER.PRODUCT_DETAILS.ADD_TO_CART' | translate }}
            </button>
        </div>
    </ng-container>
</ng-container>
